import React, { useState } from "react";

import SignupBySegmentModal from "@/components/organisms/SignupBySegmentModal";
import { useViewport } from "@/contexts/ViewportContext";
import { useAppNavigation } from "@/hooks/application/navigation";
import { useLogin } from "@/hooks/domain/auth";
import { AuthNavigation } from "@/navigation/stacks/AuthenticationStack";
import { registerForPushNotificationsAsync } from "@/services/notification";
import { isNativeDevice } from "@/utils/platform";

import LoginMobile from "./Login.mobile";
import LoginWeb from "./Login.web";
import { LoginFormData } from "./schema";

const Login = () => {
  const { isWebMode } = useViewport();

  const { goBack, navigate } = useAppNavigation<AuthNavigation>();

  const { mutate, isLoading } = useLogin();

  const [modalSegmentVisible, setModalSegmentVisible] = useState(false);

  const onSubmit = async (data: LoginFormData) => {
    let notificationToken = undefined;
    if (isNativeDevice) {
      notificationToken = await registerForPushNotificationsAsync();
    }
    mutate({
      email: data.email.trim(),
      password: data.password.trim(),
      notificationToken,
    });
  };

  const onBack = () => goBack();

  const onSingUp = () => setModalSegmentVisible(true);

  const onRecoveryPass = () => navigate("recoveryPassword");

  const Screen = isWebMode ? LoginWeb : LoginMobile;

  return (
    <>
      <Screen
        isSubmiting={isLoading}
        onSubmit={onSubmit}
        onBack={onBack}
        onSingUp={onSingUp}
        onRecoveryPass={onRecoveryPass}
      />
      <SignupBySegmentModal
        modalVisible={modalSegmentVisible}
        onClose={() => setModalSegmentVisible(false)}
      />
    </>
  );
};

export default Login;
